"use client"

import { Routes, Route, Navigate, useParams } from "react-router-dom"
import { useSelector } from "react-redux"

// 레이아웃
import MainLayout from "./layout/MainLayout"

// 페이지
import Home from "./pages/contents/Home"
import ChurchInformation from "./pages/contents/ChurchInformation"
import WorshipInformation from "./pages/contents/WorshipInformation"
import NewFamilyInformation from "./pages/contents/NewFamilyInformation"
import Directions from "./pages/contents/Directions"
import Infant from "./pages/contents/Infant"
import YouthGroup from "./pages/contents/YouthGroup"
import Youth from "./pages/contents/Youth"
import Kindergarten from "./pages/contents/Kindergarten"
import Login from "./pages/contents/Login"
import Token from "./pages/common/Token"
import InfoInput from "./pages/contents/infoInput"
import ChurchNews from "./pages/contents/ChurchNews"
import Weekly from "./pages/contents/Weekly"
import WeeklyWrite from "./pages/contents/WeeklyWrite"
import SermonVideos from "./pages/contents/SermonVideos"
import Video from "../components/pages/Video"
import ChildrensMinistry from "./pages/contents/ChildrensMinistry"
import ChurchNewsDetail from "./pages/contents/ChurchNewsDetail"
import ChurchNewsWrite from "./pages/contents/ChurchNewsWrite"
import HakkumI from "./pages/contents/HakumI"
import Clubs from "./pages/contents/Clubs"
import ClubDetail from "./pages/contents/ClubDetail"
import ClubWrite from "./pages/contents/ClubWrite"
import ClubEdit from "./pages/contents/ClubEdit"
import ChurchOrganization from "./pages/contents/ChurchOrganization"
import ChurchHistory from "./pages/contents/ChurchHistory"
import PrivacyPolicy from "./pages/contents/PrivacyPolicy"

// 정보 입력 필요 여부 확인하는 래퍼 컴포넌트
const RequireInfoCheck = ({ children }) => {
    const { isLogin, isInfo } = useSelector((state) => state.login)

    // 로그인 상태이고 정보가 입력되지 않은 경우 info-input으로 리다이렉트
    if (isLogin && !isInfo) {
        return <Navigate to="/info-input" replace />
    }

    return children
}

// 기존 복잡한 URL을 새 URL로 리다이렉트하는 컴포넌트
const ChurchNewsRedirect = () => {
    const { boardId, id } = useParams()
    return <Navigate to={`/church-news/${id}`} replace />
}

const ClubDetailRedirect = () => {
    const { id } = useParams()
    return <Navigate to={`/clubs/${id}`} replace />
}

function CommonRouter() {
    return (
        <Routes>
            <Route element={<MainLayout />}>
                {/* 메인 페이지 */}
                <Route
                    path="/"
                    element={
                        <RequireInfoCheck>
                            <Home />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/home"
                    element={
                        <RequireInfoCheck>
                            <Home />
                        </RequireInfoCheck>
                    }
                ></Route>

                {/* 인증 관련 */}
                <Route path="/login" element={<Login />}></Route>
                <Route path="/token" element={<Token />}></Route>
                <Route path="/info-input" element={<InfoInput />}></Route>

                {/* 교회 정보 */}
                <Route
                    path="/church-information"
                    element={
                        <RequireInfoCheck>
                            <ChurchInformation />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/worship-information"
                    element={
                        <RequireInfoCheck>
                            <WorshipInformation />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/new-family-information"
                    element={
                        <RequireInfoCheck>
                            <NewFamilyInformation />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/directions"
                    element={
                        <RequireInfoCheck>
                            <Directions />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/organization"
                    element={
                        <RequireInfoCheck>
                            <ChurchOrganization />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/church-history"
                    element={
                        <RequireInfoCheck>
                            <ChurchHistory />
                        </RequireInfoCheck>
                    }
                ></Route>

                {/* 부서 정보 */}
                <Route
                    path="/infant"
                    element={
                        <RequireInfoCheck>
                            <Infant />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/kindergarten"
                    element={
                        <RequireInfoCheck>
                            <Kindergarten />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/childrens-ministry"
                    element={
                        <RequireInfoCheck>
                            <ChildrensMinistry />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/youth"
                    element={
                        <RequireInfoCheck>
                            <Youth />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/youth-group"
                    element={
                        <RequireInfoCheck>
                            <YouthGroup />
                        </RequireInfoCheck>
                    }
                ></Route>

                {/* 설교영상 관련 */}
                <Route
                    path="/sermon-videos"
                    element={
                        <RequireInfoCheck>
                            <SermonVideos />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/sermonVideos"
                    element={
                        <RequireInfoCheck>
                            <SermonVideos />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/videos"
                    element={
                        <RequireInfoCheck>
                            <SermonVideos />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/video/:youtubeId/:youtubeObjectId"
                    element={
                        <RequireInfoCheck>
                            <Video />
                        </RequireInfoCheck>
                    }
                ></Route>

                {/* 교회 소식 - 단순화된 URL 구조 */}
                <Route
                    path="/church-news"
                    element={
                        <RequireInfoCheck>
                            <ChurchNews />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/church-news/write"
                    element={
                        <RequireInfoCheck>
                            <ChurchNewsWrite />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/church-news/edit/:id"
                    element={
                        <RequireInfoCheck>
                            <ChurchNewsWrite />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/church-news/:id"
                    element={
                        <RequireInfoCheck>
                            <ChurchNewsDetail />
                        </RequireInfoCheck>
                    }
                ></Route>

                {/* 주보 */}
                <Route
                    path="/weekly"
                    element={
                        <RequireInfoCheck>
                            <Weekly />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/weekly/write"
                    element={
                        <RequireInfoCheck>
                            <WeeklyWrite />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/weekly/edit/:id"
                    element={
                        <RequireInfoCheck>
                            <WeeklyWrite />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/weekly/:id"
                    element={
                        <RequireInfoCheck>
                            <WeeklyWrite />
                        </RequireInfoCheck>
                    }
                ></Route>

                {/* 동아리 */}
                <Route
                    path="/clubs"
                    element={
                        <RequireInfoCheck>
                            <Clubs />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/clubs/write"
                    element={
                        <RequireInfoCheck>
                            <ClubWrite />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/clubs/edit/:id"
                    element={
                        <RequireInfoCheck>
                            <ClubEdit />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/clubs/:id"
                    element={
                        <RequireInfoCheck>
                            <ClubDetail />
                        </RequireInfoCheck>
                    }
                ></Route>

                {/* 기타 */}
                <Route
                    path="/hakkum-i"
                    element={
                        <RequireInfoCheck>
                            <HakkumI />
                        </RequireInfoCheck>
                    }
                ></Route>
                <Route
                    path="/privacy-policy"
                    element={
                        <RequireInfoCheck>
                            <PrivacyPolicy />
                        </RequireInfoCheck>
                    }
                ></Route>

                {/* 기존 호환성 유지를 위한 리다이렉트 라우트 */}
                <Route path="/church-news/:boardId/:id" element={<ChurchNewsRedirect />}></Route>
                <Route path="/clubs/detail/:id" element={<ClubDetailRedirect />}></Route>

                {/* 중복 라우트 정리 (기존 호환성 유지) */}
                <Route path="/church-information" element={<ChurchInformation />}></Route>
                <Route path="/worship-information" element={<WorshipInformation />}></Route>
                <Route path="/new-family-information" element={<NewFamilyInformation />}></Route>
                <Route path="/directions" element={<Directions />}></Route>
                <Route path="/video/:youtubeId/:youtubeObjectId" element={<Video />}></Route>
                <Route path="/sermon-videos" element={<SermonVideos />}></Route>
                <Route path="/sermonVideos" element={<SermonVideos />}></Route>
                <Route path="/videos" element={<SermonVideos />}></Route>
                <Route path="/organization" element={<ChurchOrganization />}></Route>
                <Route path="/infant" element={<Infant />}></Route>
                <Route path="/kindergarten" element={<Kindergarten />}></Route>
                <Route path="/childrens-ministry" element={<ChildrensMinistry />}></Route>
                <Route path="/youth" element={<Youth />}></Route>
                <Route path="/youth-group" element={<YouthGroup />}></Route>
                <Route path="/church-news" element={<ChurchNews />}></Route>
                <Route path="/weekly" element={<Weekly />}></Route>
                <Route path="/weekly/write" element={<WeeklyWrite />}></Route>
                <Route path="/weekly/edit/:id" element={<WeeklyWrite />}></Route>
                <Route path="/hakkum-ai" element={<HakkumI />}></Route>
                <Route path="/info-input" element={<InfoInput />}></Route>
                <Route path="/church-history" element={<ChurchHistory />}></Route>
            </Route>
        </Routes>
    )
}

export default CommonRouter
